
/**
 * Contains methods for handling scroll events on the header
 *
 * @type {Header}
 */
var Header;

Header = (function() {

  /**
   * A map of key codes
   *
   * @type {object}
   */
  var keyCodes, toggle;

  keyCodes = {
    ESC: 27
  };


  /**
   * The documentation link in the main menu
   *
   * @type {HTMLElement}
   */

  toggle = document.querySelector('.nav--main-mobile-nav-link');


  /**
   * Create the Header instance
   *
   * @return {Header}
   */

  function Header() {
    this.header = document.querySelector('.nav');
    this.registerNavListeners();
    this.registerHeaderScrollingListener();
    this.updateVersion();
  }


  /**
   * Register listeners for opening and closing the documentation navigation
   */

  Header.prototype.registerNavListeners = function() {
    toggle.addEventListener('click', function(evt) {
      evt.preventDefault();
      if (document.body.classList.contains('menu--open')) {
        return document.body.classList.remove('menu--open');
      } else {
        return document.body.classList.add('menu--open');
      }
    });
    return document.addEventListener('keydown', function(evt) {
      var key, open;
      key = evt.keyCode || evt.which;
      open = document.body.classList.contains('menu--open');
      if (open && key === keyCodes.ESC) {
        return document.body.classList.remove('menu--open');
      }
    });
  };


  /**
   * Register a listener which fires on scroll events
   */

  Header.prototype.registerHeaderScrollingListener = function() {
    return window.addEventListener('scroll', this.fixHeaderOnScroll);
  };


  /**
   * Fix the header to the top of the screen once the
   * scroll position reaches it
   *
   * @param  {Event} evt
   */

  Header.prototype.fixHeaderOnScroll = function(evt) {
    var y;
    y = window.pageYOffset;
    if (y > 100) {
      return document.body.classList.add('scrolled');
    } else {
      return document.body.classList.remove('scrolled');
    }
  };


  /**
   * Get the latest version number from Github's API,
   * and update version placeholders across the site
   */

  Header.prototype.updateVersion = function() {
    var installDocs, placeholder;
    placeholder = document.querySelector('.nav--main-install-version');
    installDocs = document.querySelector('.install--version-instructions code');
    return this.getLatestRelease().then(function(version) {
      placeholder.innerHTML = version;
      return installDocs.innerHTML = installDocs.innerHTML.replace(/__version__/g, version);
    });
  };


  /**
   * Get the latest version number from Github's API
   *
   * @return {Promise}
   */

  Header.prototype.getLatestRelease = function() {
    return new Promise(function(resolve, reject) {
      var next, timestamp, updatedAt, url, version;
      updatedAt = parseInt(localStorage.getItem('version_updated_at'));
      timestamp = new Date().getTime();
      if ((updatedAt + 300) > timestamp) {
        version = localStorage.getItem('version');
        resolve(version);
        return;
      }
      url = 'https://api.github.com/repos/zunit-zsh/zunit/releases/latest';
      if (window.baseDomain !== 'https://zunit.xyz') {
        next = true;
        url = 'https://api.github.com/repos/zunit-zsh/zunit/releases';
      }
      return fetch(url).then(function(response) {
        return response.json();
      }).then(function(response) {
        if (next) {
          return response[0];
        }
        return response;
      }).then(function(response) {
        localStorage.setItem('version', response.tag_name);
        localStorage.setItem('version_updated_at', timestamp);
        return resolve(response.tag_name);
      })["catch"](function(err) {
        return reject(err);
      });
    });
  };

  return Header;

})();

module.exports = Header;

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
